<template>
  <div class="iv-stat-cards">
    <div class="iv-stat-card">
      <div class="iv-stat-icon iv-stat-icon--teal">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
      </div>
      <div class="iv-stat-body">
        <div class="iv-stat-num">{{ loading ? '—' : (stats.verified || 0) }}</div>
        <div class="iv-stat-label">Verified insurance</div>
      </div>
    </div>

    <div class="iv-stat-card">
      <div class="iv-stat-icon iv-stat-icon--red">
        <i class="fa fa-times-circle" aria-hidden="true"></i>
      </div>
      <div class="iv-stat-body">
        <div class="iv-stat-num">{{ loading ? '—' : (stats.needAttention || 0) }}</div>
        <div class="iv-stat-label">Need attention</div>
      </div>
    </div>

    <div class="iv-stat-card">
      <div class="iv-stat-icon iv-stat-icon--amber">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="iv-stat-body">
        <div class="iv-stat-num">{{ loading ? '—' : (stats.coverageAlerts || 0) }}</div>
        <div class="iv-stat-label">Coverage alerts</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'StatCards',
  props: {
    stats: {
      type: Object,
      default: () => ({ verified: 0, needAttention: 0, coverageAlerts: 0 }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.iv-stat-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
}

.iv-stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #dfe4e3;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(12, 15, 14, 0.05);
  padding: 18px 20px;
}

.iv-stat-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-size: 22px;

  &--teal {
    background: #e9f6f1;
    color: #0f7259;
  }
  &--red {
    background: #fdeeee;
    color: #e5484d;
  }
  &--amber {
    background: #fef6e7;
    color: #f59e0b;
  }
}

.iv-stat-num {
  font-weight: 800;
  font-size: 34px;
  line-height: 1;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: #0c0f0e;
}

.iv-stat-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #717977;
  margin-top: 7px;
}
</style>
